import { ArrowRight, InboxOutlined, Inventory2Outlined } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'
import { Bin } from 'chezy-inventory-backend/bin/database/types/Bin'
import { Link } from 'react-router-dom'

export const BinPath = (props: { binPath: Bin[]; noLinks?: boolean }) => {
  if ((props.binPath ?? []).length === 0) {
    return <div></div>
  }
  const LinkEl = !props.noLinks ? Link : Box
  return (
    <Box
      style={{
        marginLeft: '10px',
        display: 'flex',
        flexDirection: 'row',
        color: '#555',
        flexWrap: 'wrap',
      }}
    >
      <Typography>Located in:&nbsp;</Typography>
      {(props.binPath ?? []).flatMap((bin, idx) => [
        <LinkEl
          style={{
            display: 'flex',
            flexDirection: 'row',
            textDecoration: 'none',
            color: '#555',
          }}
          to={`/bin/${bin.id}`}
        >
          {!bin.parent_id ? <Inventory2Outlined /> : <InboxOutlined />}
          <Typography> &nbsp; {bin.name}</Typography>
        </LinkEl>,
        idx === props.binPath.length - 1 ? undefined : <ArrowRight />,
      ])}
    </Box>
  )
}
